import { getCookie, isTestEnvironment } from '@/resources/utils'
import { logger } from './logger'

const ENCRYPTION_KEY = isTestEnvironment
  ? 'test-encryption'
  : process.env.GLASSBOX_ENCRYPTION_KEY

const encryptEmailForGlassbox = (email?: string): string | null => {
  if (!email || !ENCRYPTION_KEY) return null

  try {
    const normalized = email.toLowerCase().trim()
    let encrypted = ''

    for (let i = 0; i < normalized.length; i++) {
      const emailChar = normalized.codePointAt(i)
      const keyChar = ENCRYPTION_KEY.codePointAt(i % ENCRYPTION_KEY.length)
      if (emailChar && keyChar) {
        encrypted += String.fromCodePoint(emailChar ^ keyChar)
      }
    }

    return btoa(encrypted)
  } catch {
    logger.error('[Glassbox] Error encrypting email.')
    return null
  }
}

const sendInformationToGlassbox = (event: string, value: string) => {
  if (!globalThis._detector) return

  try {
    globalThis._detector.triggerCustomEvent(event, value)
  } catch {
    // ignore known glassbox api type error
  }
}

export const glassboxSetUserInfo = (pocId: number, retries = 2) => {
  const email = getCookie('email')
  const encryptedEmail = email ? encryptEmailForGlassbox(email) : null
  const storeId = String(pocId)

  if (!globalThis._detector && retries > 0) {
    setTimeout(() => {
      glassboxSetUserInfo(pocId, retries - 1)
    }, 2000)
    return
  }

  if (encryptedEmail) sendInformationToGlassbox('userId', encryptedEmail)
  sendInformationToGlassbox('storeId', `store_${storeId}`)
}

declare global {
  var _detector: {
    triggerCustomEvent: (eventName: string, eventData: string) => void
  }
}
